import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    keyboardShortcut: {
      ...theme.typography.body1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      color: theme.palette.greyBlue[700],
      gap: theme.spacing(1.25),
      ['@media (max-width:370px)']: {
        flexDirection: 'column',
        alignItems: 'start',
      },
    },
    buttons: {
      display: 'flex',
    },
    button: {
      display: 'flex',
      height: theme.spacing(4.5),
      minWidth: theme.spacing(4.5),
      justifyContent: 'center',
      alignItems: 'center',
      border: `1px solid ${theme.palette.greyBlue[100]}`,
      borderRadius: '4px',
    },
    buttonString: {
      padding: '0 15px',
      whiteSpace: 'nowrap',
    },
    plus: {
      display: 'flex',
      width: '24px',
      alignItems: 'center',
      justifyContent: 'center',
    },
  };
});

const KeyboardShortcut = ({ children, ...props }) => {
  const classes = useStyles();

  return (
    <div className={classes.keyboardShortcut} {...props}>
      <div>{children?.name}</div>
      <div className={classes.buttons}>
        {children?.buttons.map((button, index) => (
          <React.Fragment key={button}>
            <div
              className={clsx(
                classes.button,
                typeof button === 'string' && button.length > 1
                  ? clsx(classes.buttonString, 'noTranslate')
                  : null,
              )}
            >
              {button}
            </div>
            {index !== children.buttons.length - 1 ? (
              <span className={classes.plus}>+</span>
            ) : null}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

KeyboardShortcut.propTypes = {
  children: PropTypes.shape({
    name: PropTypes.string.isRequired,
    buttons: PropTypes.array.isRequired,
  }),
};

export default KeyboardShortcut;
